const reDataUri = /^data:/

// List of available transformations
// https://cloudinary.com/documentation/image_transformation_reference#quality_parameter
export default function toCloudinaryUrl(
  cloudinaryURL,
  url,
  width,
  height,
  op,
  box,
  crop,
  radius,
  angle,
  effect,
  opacity,
  quality,
  format
) {
  let transformations = 'c_fill,q_auto,'
  const isBox = box && box.length > 0
  if (!url) return null

  // Check if url is data-uri
  if (reDataUri.test(url)) return url

  if (width) {
    transformations = transformations.concat(`w_${width},`)
  }

  if (height) {
    transformations = transformations.concat(`h_${height},`)
  }

  if (op === 'contain') {
    transformations = transformations.concat(`c_fit,`)
  }

  if (op === 'padding') {
    transformations = transformations.concat(`c_pad,`)
  }

  if (!isBox && op === 'balance') {
    transformations = transformations.concat(`g_auto,`)
  }

  if (crop) {
    transformations = transformations.concat(`c_${crop},`)
  }

  if (radius) {
    transformations = transformations.concat(`r_${radius},`)
  }

  if (angle) {
    transformations = transformations.concat(`a_${angle},`)
  }

  if (effect) {
    transformations = transformations.concat(`e_${effect},`)
  }

  if (opacity) {
    transformations = transformations.concat(`o_${opacity},`)
  }

  if (quality) {
    transformations = transformations.concat(`q_${quality},`)
  }

  if (isBox) {
    const x = box[0]
    const y = box[1]
    const w = box[2] - box[0]
    const h = box[3] - box[1]

    transformations = transformations.concat(
      `x_${x},y_${y},w_${w},h_${h},c_crop/w_auto,h_${height},`
    )
  }

  transformations = transformations.concat(`f_${format ? format : `auto`}`)

  return `${cloudinaryURL}/fetch/${transformations}/${url}`
}
